<template>
  <div class="home-container" :style="{ overflow: showLevelDetails ? 'hidden' : 'scroll' }">
    <div class="top-bar">
      <div class="top-bar-left" @click="showShare = true">
        <img src="../../assets/share.svg" alt="" />
      </div>
      <div class="top-bar-mid">
        <img :src="configInfo.site_logo" alt="" />{{ configInfo.site_name }}
      </div>
      <div class="top-bar-right" @click="languageShow = true">
        {{ curLanguage }}
      </div>
    </div>
    <div class="content-top" v-if="showBanner">
      <div class="receive-btn" @click="join">
        {{ userInfo.is_authorized ? $t("received") : $t("receive") }}
      </div>
    </div>
    <div class="content-top only-btn" v-else>
      <div class="receive-btn" @click="join">
        {{ userInfo.is_authorized ? $t("received") : $t("receive") }}
      </div>
    </div>
    <van-tabs v-model="active" color="#1d5786" title-inactive-color="#a3a2af" background="#f9fafb">
      <van-tab :title="$t('mining_pool')"></van-tab>
      <van-tab :title="$t('account')"></van-tab>
    </van-tabs>
    <div class="mining-tab" v-if="active == 0">
      <div class="data-box">
        <div class="data-box-line"></div>
        <div class="data-box-title">
          {{ $t("pool_data") }}
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("total_output") }}
          </div>
          <div class="between-right">{{ miningStat.total_product }} ETH</div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("valid_node") }}
          </div>
          <div class="between-right">{{ miningStat.valid_node }}</div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("participant") }}
          </div>
          <div class="between-right">{{ miningStat.players }}</div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("user_revenue") }}
          </div>
          <div class="between-right">{{ miningStat.earn }} USDT</div>
        </div>
      </div>
      <div class="data-box">
        <div class="data-box-line"></div>
        <div class="data-box-title">
          {{ $t("activity") }}
        </div>
        <div class="data-box-rate-top" v-if="false">
          <div class="rate-top-title">Benefits of Being an Agent</div>
          <div class="rate-top-bar">
            <p style="line-height: 1">
              <span style="
                  color: var(--text-blue-color);
                  font-weight: bold;
                  font-size: 12px;
                ">VIP Level&nbsp; &nbsp;&nbsp;</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="
                  color: var(--text-blue-color);
                  font-weight: bold;
                  font-size: 12px;
                ">PH/S&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; Total PH/S</span>
            </p>
          </div>
          <div class="ph" style="line-height: 1.7" v-for="(item, index) in notStakingRateList" :key="item.id">
            <font color="#424242" face="Arial"><span style="font-size: 12px">VIP{{ index + 1 }}</span>
              <span style="font-size: 12px">{{ decimalPh(item.rate) }} PH/S ≈
                {{ decimalRate(item.rate) }}%</span><span style="font-size: 12px">Basic + {{ decimalPh(item.rate) }}
                PH/S</span>
            </font>
          </div>
          <div class="rate-top-tip">
            <span style="font-size: 8px">Total interest rate = daily interest rate of the deposit +
              additional daily interest rate for inviting friends</span>
          </div>
          <div class="rate-top-line">
            <div class="line"></div>
          </div>
        </div>
        <div class="data-box-rate-bot">
          <div class="data-box-rate-bot-title">
            {{
              $i18n.locale != "vi"
                ? "Daily interest rate levels of income"
                : "Mức lãi suất hàng ngày của thu nhập"
            }}
          </div>
          <div class="rate-top-bar">
            <p style="line-height: 1">
              <span style="
                  color: var(--text-blue-color);
                  font-weight: bold;
                  font-size: 12px;
                ">VIP Level&nbsp; &nbsp;&nbsp;</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="
                  color: var(--text-blue-color);
                  font-weight: bold;
                  font-size: 12px;
                ">PH/S&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; 24/H
                {{ $i18n.locale != "vi" ? "Income" : "Thu nhập" }}</span>
            </p>
          </div>
          <div class="ph" style="line-height: 1.7" v-for="(item, index) in notStakingRateList" :key="item.id">
            <font color="#424242" face="Arial"><span style="font-size: 12px">VIP{{ index + 1 }}</span>
              <span style="font-size: 12px">{{ decimalPh4(item.rate) }} PH/S ≈
                {{ decimalRate4(item.rate) }}%</span><span style="font-size: 12px">{{ decimalInterest4(item.money,
                item.rate) }} USDT</span>
            </font>
          </div>
        </div>
      </div>
      <div class="mining-tip">
        <div class="mining-tip-title">
          {{ $t("mining") }}
        </div>
        <div class="mining-tip-tip">
          {{ $t("liquidity") }}
        </div>
      </div>
      <div class="data-box">
        <div class="data-box-line red"></div>
        <div class="data-box-title">
          {{ $t("user_output") }}
        </div>
        <div class="data-box-marquee">
          <div class="data-box-marquee-top">
            <div class="top-left">
              {{ $t("address") }}
            </div>
            <div class="top-right">
              {{ $t("quantity") }}
            </div>
          </div>
          <SoMarquee :data="jsonData" :height="200" :showNumber="8" :speed="1000" class="my-ui-marquee">
            <template v-slot:itemCon="{ item }">
              <div style="color: var(--text-com-color)">
                {{ item.address }}
              </div>
              <div style="font-weight: bold; color: var(--text-black-color)">
                {{ (item.num).toFixed(5) }} ETH
              </div>
            </template>
          </SoMarquee>
        </div>
      </div>
      <div class="mining-tip">
        <div class="mining-tip-title">
          {{ $t("help_center") }}
        </div>
        <div class="mining-tip-tip">
          {{ $t("hep_center_tip") }}
        </div>
      </div>
      <div class="question-box">
        <van-collapse v-model="activeName" accordion>
          <van-collapse-item :title="$t('question1')" name="1">{{
            $t("answer1")
            }}</van-collapse-item>
          <van-collapse-item :title="$t('question2')" name="2">{{
            $t("answer2")
            }}</van-collapse-item>
          <van-collapse-item :title="$t('question3')" name="3">{{
            $t("answer3")
            }}</van-collapse-item>
        </van-collapse>
      </div>
      <div class="mining-tip">
        <div class="mining-tip-title">
          {{ $t("audit_report") }}
        </div>
        <div class="mining-tip-tip">
          {{ $t("audit_report_tip") }}
        </div>
      </div>
      <div class="report-box">
        <div class="report-box-item" v-for="item in auditList" :key="item">
          <img :src="item" alt="" />
        </div>
      </div>
      <div class="mining-tip">
        <div class="mining-tip-title">
          {{ $t("partner") }}
        </div>
        <div class="mining-tip-tip">
          {{ $t("partner_tip") }}
        </div>
      </div>
      <div class="partner-box">
        <van-grid :column-num="3" :border="false">
          <van-grid-item v-for="value in 15" :key="value">
            <van-image width="40" :src="require('../../assets/index_partner_' + (value - 1) + '.png')
              " />
          </van-grid-item>
        </van-grid>
        <div class="partner-box-item" v-for="item in 15" :key="item"></div>
      </div>
    </div>
    <div class="mining-tab" v-if="active == 1">
      <div class="data-box" v-for="item in activityList" :key="item.id">
        <div class="data-box-line"></div>
        <div class="data-box-title">
          {{ $t("apply_mining_pool_rewards") }}
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("standard") }}
          </div>
          <div class="between-right">
            {{ item.balance_amount }} {{ item.balance_currency.toUpperCase() }}
          </div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("output") }}
          </div>
          <div class="between-right">
            {{ item.award_amount }} {{ item.award_currency.toUpperCase() }}
          </div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("total_balance") }}
          </div>
          <div class="between-right">
            {{ item.balance }} {{ item.balance_currency.toUpperCase() }}
          </div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("required") }}
          </div>
          <div class="between-right" style="color: red">
            {{ item.need_deposit }} {{ item.balance_currency.toUpperCase() }}
          </div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("countdown") }}
          </div>
          <div class="between-right" style="color: red">
            {{
              item.end_time * 1000 - new Date().getTime() > 0
                ? parseInt(
                  (item.end_time * 1000 - new Date().getTime()) / 86400000
                )
                : 0
            }}
            {{ $t("host_day") }}
          </div>
        </div>
        <div class="blue-btn" @click="receiveActivity(item.id)">
          {{ $t("reward") }}&nbsp;{{ item.award_amount }}
          {{ item.award_currency.toUpperCase() }}
        </div>
      </div>

      <div class="data-box">
        <div class="data-box-line"></div>
        <div class="data-box-title">
          {{ $t("my_account") }}
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("mining_status") }}
          </div>
          <div class="between-right">
            {{ miningStatus.mining_status }}
          </div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("total_output") }}
          </div>
          <div class="between-right">{{ notStakingMiningStat.sum }} ETH</div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("wallet_balance") }}
          </div>
          <div class="between-right">{{ userInfo.address_usdt }}USDT</div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("exchangeable") }}
          </div>
          <div class="between-right">{{ userInfo.balance_eth }} ETH</div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("withdrawable") }}
          </div>
          <div class="between-right">{{ userInfo.balance_usdt }} USDT</div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("share_dividends") }}
          </div>
          <div class="between-right">
            {{ configInfo.mining_rebate_rate_l1 }}%
          </div>
        </div>
      </div>
      <div class="data-box">
        <div class="data-box-line"></div>
        <div class="data-box-title">
          {{ $t("my_level") }}
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("level") }}
          </div>
          <div class="between-right">{{ miningStatus.level }}</div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("hash_rate") }}
          </div>
          <div class="between-right">{{ miningStatus.hash_rate }} PH/s</div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("output_interest_rate") }}
          </div>
          <div class="between-right">
            ≈{{ miningStatus.output_interest_rate }}%
          </div>
        </div>
        <div class="data-box-between">
          <div class="between-left">
            {{ $t("output_interest_cycle") }}
          </div>
          <div class="between-right">
            {{ miningStatus.output_interest_cycle }}minutes
          </div>
        </div>
        <div class="blue-btn" @click="showLevelDetails = true">
          {{ $t("level_details") }}
        </div>
      </div>
      <div class="data-box">
        <div class="data-box-line"></div>
        <div class="data-box-title">
          {{ $t("pair_price") }}
        </div>
        <div class="data-box-between">
          <div class="between-left">ETH/USDT</div>
          <div class="between-right">{{ eToU }}</div>
        </div>
        <div class="data-box-between">
          <div class="between-left">BTC/USDT</div>
          <div class="between-right">{{ bToU }}</div>
        </div>
        <div class="data-box-between">
          <div class="between-left">BTC/ETH</div>
          <div class="between-right">{{ bToE }}</div>
        </div>
      </div>
      <div class="account-tab" :class="showRecharge ? 'three' : ''">
        <van-tabs @disabled="rechargeClick" v-model="accountActive" line-height="0px">
          <van-tab disabled v-if="showRecharge" :title="$t('recharge')"></van-tab>
          <van-tab :title="$t('exchange')"></van-tab>
          <van-tab :title="$t('withdraw')"></van-tab>
        </van-tabs>
      </div>
      <div class="data-box no-top" v-if="showRecharge ? accountActive == 1 : accountActive == 0">
        <div class="data-box-line"></div>
        <div class="data-box-title">
          {{ $t("exchange") }}
        </div>
        <div class="data-box-exchange">
          <div class="input-box">
            <div class="input-box-left">
              <input type="number" placeholder="ETH" v-model="num" @input="computedMoney" />
            </div>
            <div class="input-box-right">{{ result }}</div>
            <div class="input-box-icon">
              <van-icon name="exchange" color="#489e7e" />
            </div>
          </div>
          <div class="all-coin-box">
            <div class="all" @click="redeemAll">
              {{ $t("redeem_all") }}
            </div>
            <div class="coin">
              <img src="../../assets/USDT.png" alt="" /> USDT
            </div>
          </div>
        </div>
        <div class="blue-btn" @click="exchange">
          {{ $t("exchange") }}
        </div>
      </div>
      <div class="data-box no-top" v-if="showRecharge ? accountActive == 2 : accountActive == 1">
        <div class="data-box-title" @click="withdraw">
          {{ $t("withdraw") }}
        </div>
        <div class="data-box-line"></div>
        <div class="data-box-withdraw">
          <div class="data-box-withdraw-top">
            <div class="withdraw-left">
              <input type="text" placeholder="USDT" v-model="withdrawMoney" />
            </div>
            <div class="withdraw-line"></div>
            <div class="withdraw-coin">
              <img src="../../assets/USDT.png" alt="" /> USDT
            </div>
          </div>
          <div class="total" @click="totalWithdraw">
            {{ $t("total_balance") }}
          </div>
        </div>
        <div class="blue-btn" @click="withdraw">
          {{ $t("withdraw") }}
        </div>
      </div>
      <div class="blue-btn" @click="goRecord">
        {{ $t("record") }}
      </div>
      <div class="vip-level" v-if="showVIP !== 'false'">VIP{{ miningStatus.balance_level }}</div>
    </div>
    <div class="content-bot">
      <div class="content-bot-title">
        <img :src="configInfo.site_logo" alt="" />{{ configInfo.site_name }}
      </div>
      <div class="content-bot-btn" v-if="showWhitePaper !== 'false'" @click="openWhitePaper">White paper</div>
    </div>
    <div class="address" v-if="!showCover" v-clipboard:copy="userInfo.address" v-clipboard:success="onAddressCopy">
      <img src="../../assets/link.svg" alt="" />{{
        userInfo.address ? userInfo.address.substring(0, 6) : ""
      }}
    </div>
    <van-overlay :show="showLevelDetails" @mousewheel.prevent :custom-style="{ zIndex: 9999 }" lock-scroll
      @click="showLevelDetails = false">
      <div class="wrapper" @mousewheel.prevent @click.stop>
        <van-nav-bar :title="$t('level_details')" :left-text="$t('back')" left-arrow @click-left="onClickLeft" />
        <div class="level-details-bot">
          <div class="level-list">
            <div class="level-list-row bar">
              <div class="level-list-row-item">
                {{ $t("wallet_balance") }}
              </div>
              <div class="level-list-row-item">
                {{ $t("hash_rate") }}
              </div>
              <div class="level-list-row-item">
                {{ $t("output_interest") }}
              </div>
            </div>
            <div class="level-list-row" v-for="(item, index) in notStakingRateList" :key="index">
              <div class="level-list-row-item">
                {{ item.money }}~{{
                  notStakingRateList[index + 1]
                    ? notStakingRateList[index + 1].money - 1
                    : "∞"
                }}
              </div>
              <div class="level-list-row-item">
                {{ decimalPh4(item.rate) }}PH/s
              </div>
              <div class="level-list-row-item">
                ≈{{ decimalRate4(item.rate) }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showShare" @mousewheel.prevent :custom-style="{ zIndex: 1999 }" lock-scroll>
      <div class="share-box">
        <div class="share-box-bar">
          <div class="share-box-bar-left">
            <div class="left-line"></div>
            <div class="left-title">
              {{ $t("share_friends") }}
            </div>
          </div>
          <div class="share-box-bar-right" @click="showShare = false">
            <van-icon name="cross" size="30px" color="#999" />
          </div>
        </div>
        <div class="share-box-img">
          <img src="../../assets/share_bg.jpg" alt="" />
        </div>
        <div class="share-box-link">
          <div class="link-title">
            {{ $t("my_share_link") }}
          </div>
          <div class="link-bar">
            <div class="link-bar-left">{{ inviteUrl }}</div>
            <div class="link-bar-right" v-clipboard:copy="inviteUrl" v-clipboard:success="onCopy">
              {{ $t("copy") }}
            </div>
          </div>
        </div>
        <div class="share-box-tip">
          {{ $t("share_tip") }}
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="languageShow" style="height: 50%" position="bottom" round>
      <div class="language-box">
        <div class="language-box-item" @click="changeLanguage(item.key, item.title)" v-for="item in languageList"
          :key="item.id">
          {{ item.title }}
        </div>
      </div>
    </van-popup>
    <div class="contact-btn" v-if="showServiceBtn && !showCover" @click="showService">
      <img src="../../assets/kefu.png" alt="" />
    </div>
    <van-popup v-model="serviceShow" style="width: 90%; border-radius: 10px">
      <div class="service-box">
        <div class="service-box-btn" v-if="serviceUrl && serviceUrl.url" @click="goService">
          {{ $t("home_service") }}
        </div>
        <div class="service-box-btn" v-if="serviceUrl && serviceUrl.telegram" v-clipboard:copy="serviceUrl.telegram"
          v-clipboard:success="onCopy">
          Telegram({{ serviceUrl.telegram }})
        </div>
        <div class="service-box-btn" v-clipboard:copy="serviceUrl.email" v-clipboard:success="onCopy"
          v-if="serviceUrl && serviceUrl.email">
          Email({{ serviceUrl.email }})
        </div>
      </div>
    </van-popup>
    <van-popup style="width: 90%" :close-on-click-overlay="false" v-model="showMessage" round>
      <div class="msg-box" v-if="messageList[messageIndex]">
        <div class="msg-box-title">
          {{
            messageList[messageIndex].title
              ? messageList[messageIndex].title
              : ""
          }}
        </div>
        <div class="msg-box-content" v-html="messageList[messageIndex].content"></div>
        <div class="msg-box-btn" @click="readMessage">
          {{ $t("i_know") }}
        </div>
      </div>
    </van-popup>
    <van-popup style="
        width: 90%;
        border-radius: 10px;
        padding-top: 30px;
        background: transparent;
      " :close-on-click-overlay="false" v-model="showActivity">
      <div class="pop-activity-box">
        <div class="pop-activity-box-tri">
          <div class="close" @click="closeActivity" v-if="airdorpCloseBtn === 'top'">
            <van-icon name="clear" color="#999999" size="30px" />
          </div>
          <div class="tri-top"></div>
          <div class="tri-bot"></div>
          <img src="../../assets/pop-label.png" alt="" />
        </div>
        <div class="pop-activity-box-title">
          {{ $t("popup_miniing_title") }}
        </div>
        <div class="pop-activity-box-content" v-if="activityInfo">
          <div class="content-between">
            <div class="between-left">
              {{ $t("standard") }}
            </div>
            <div class="between-right">
              {{ activityInfo.balance_amount }}
              {{ activityInfo.balance_currency.toUpperCase() }}
            </div>
          </div>
          <div class="content-between">
            <div class="between-left">
              {{ $t("output") }}
            </div>
            <div class="between-right">
              {{ activityInfo.award_amount }}
              {{ activityInfo.award_currency.toUpperCase() }}
            </div>
          </div>
          <div class="content-between">
            <div class="between-left">
              {{ $t("total_balance") }}
            </div>
            <div class="between-right">
              {{ activityInfo.balance }}
              {{ activityInfo.balance_currency.toUpperCase() }}
            </div>
          </div>
          <div class="content-between">
            <div class="between-left">
              {{ $t("required") }}
            </div>
            <div class="between-right" style="color: red">
              {{ activityInfo.need_deposit }}
              {{ activityInfo.balance_currency.toUpperCase() }}
            </div>
          </div>
          <div class="content-between">
            <div class="between-left">
              {{ $t("countdown") }}
            </div>
            <div class="between-right" style="color: red">
              {{
                activityInfo.end_time * 1000 - new Date().getTime() > 0
                  ? parseInt(
                    (activityInfo.end_time * 1000 - new Date().getTime()) /
                    86400000
                  )
                  : 0
              }}
              {{ $t("host_day") }}
            </div>
          </div>
        </div>
        <div class="pop-activity-box-btn" @click="applyReward" style="background: #2f91ff">
          {{ $t("popup_miniing_btn") }}
        </div>
        <div class="clear-btn-false" @click="closeActivity" v-if="
          airdorpCloseBtn !== 'top' &&
          airdorpCloseBtn !== 'disable'
        ">
          <van-icon name="clear" color="#999999" size="40px" />
        </div>
      </div>
    </van-popup>
    <van-popup style="width: 90%; border-radius: 12px; background: #000" :close-on-click-overlay="false"
      v-model="showNewActivity">
      <div class="new-activity-box">
        <div class="new-top">
          <div class="new-top-left">
            <img src="../../assets/ETH.png" alt="" />{{ $t("activity-top-title") }}
          </div>
          <div class="new-top-right" @click="closeActivity" v-if="airdorpCloseBtn !== 'disable'">
            <van-icon name="close" size="26px" />
          </div>
        </div>
        <div class="title">
          {{ $t("activity-top-big-title") }}
        </div>
        <div class="activity-top-tip">
          {{ $t("activity-top-tip") }}
        </div>
        <div class="activity-top-end" v-if="activityList.length > 0">
          <img src="../../assets/activity-end.svg" alt="" />
          {{ $t("activity-end") }}:
          {{
            (activityList[0].end_time * 1000)
            | dateFormat("MM/dd/yyyy hh:mm:ss")
          }}
        </div>
        <div class="activity-top-img">
          <img src="../../assets/activity-coin.jpg" alt="" />
        </div>
        <div class="join-btn" @click="applyReward">
          {{ $t("activity-join") }}
        </div>
      </div>
    </van-popup>
    <div v-if="showCover" class="white-cover"></div>
  </div>
</template>

<script>
import SoMarquee from "@/components/SoMarquee";
import userOutPut from "@/utils/userOutput";
import { Decimal } from "decimal.js";
import { Notify, Toast } from "vant";
import tools from '@/utils/tools'

export default {
  components: {
    SoMarquee,
  },
  data() {
    return {
      activityInfo: "",
      activityList: [],
      showActivity: false,
      messageList: [],
      messageIndex: 0,
      showMessage: false,
      serviceShow: false,
      serviceUrl: undefined,
      showShare: false,
      accountActive: 0,
      active: 0,
      jsonData: "",
      activeName: "1",
      auditList: [
        require("../../assets/audit1.png"),
        require("../../assets/audit2.png"),
        require("../../assets/audit3.png"),
      ],
      userInfo: "",
      miningStat: "",
      notStakingRateList: [],
      incomeStat: "",
      notStakingMiningStat: "",
      showLevelDetails: false,
      currencyRate: [],
      exchangeRate: 0,
      num: "",
      result: 0,
      languagePackList: ["en", "ja", "ind", "vi", "th"],
      languageList: [],
      curLanguage: "English",
      languageShow: false,
      userAddress: "",
      withdrawMoney: "",
      eToU: 0,
      bToU: 0,
      bToE: 0,
      miningStatus: "",
      inviteUrl: "",
      configInfo: "",
      showBanner: false,
      showServiceBtn: false,
      airdorpCloseBtn: true,
      showCover: true,
      showRecharge: false,
      showNewActivity: false,
      showWhitePaper: "",
      showVIP: "",
    };
  },
  async created() {
    this.jsonData = userOutPut.data;
    this.getLanguageList();
    this.getNotStakingMiningRate();
    this.getService();
    this.getConfig();
    this.getRechargeConfig();
    // await this.getConfig();
    this.$store.commit("changeRequestStatus", false);
  },
  async mounted() {
    this.showBanner = process.env.VUE_APP_SHOW_BANNER;
    this.showServiceBtn = process.env.VUE_APP_SHOW_SERVICE;
    this.airdorpCloseBtn = process.env.VUE_APP_AIRDORP_CLOSE_BTN;
    console.log(this.airdorpCloseBtn)
    this.showWhitePaper = process.env.VUE_APP_SHOW_WHITE_PAPER;
    this.showVIP = process.env.VUE_APP_SHOW_VIP;
    if (this.showRecharge) {
      this.accountActive = 1;
    }
    this.getCurrencyRate();
    await this.$onLaunched;
    this.change = false;
    this.showCover = false;
    this.getUserInfo();
    this.getMiningStat();
    this.getIncomeStat();
    this.getNotStakingMiningStat();
    this.getMiningStatus();
    this.getNewMessage();
    this.getActivityList();
    setInterval(async () => {
      this.getUserInfo();
      this.getMiningStatus();
      this.getNotStakingMiningStat();
    }, 10000);
  },
  methods: {
    async getRechargeConfig() {
      const res = await this.$api.getRechargeConfig();
      if (res.code == 200) {
        if (!res.data || res.data.length == 0) {
          this.showRecharge = false;
        } else {
          this.showRecharge = true;
        }
      }
    },
    rechargeClick(e) {
      this.$router.push("/recharge");
    },
    async receiveActivity(id) {
      const res = await this.$api.receiveActivity({ id });
      if (res.code == 200) {
        this.$Toast(this.$t("successful application"));
        this.getActivityList();
        location.reload();
      } else {
        this.$Toast(res.message);
      }
    },
    async closeActivity() {
      let id = this.activityList.filter(
        (item) => item.status == 1 || item.status == 4
      )[0].id;
      const res = await this.$api.closeActivity({ id });
      if (res.code == 200) {
        if (process.env.VUE_APP_ACTIVITY_POP == "v2") {
          this.showNewActivity = false;
        } else {
          this.showActivity = false;
        }
        if(res.data.read){
          this.getActivityList();
          localStorage.setItem("typeActive", 0);
          this.active = 1;
        }else{
          this.activityList = [];
        }
      } else {
        this.$Toast(res.message);
      }
    },
    async applyReward() {
      this.$Toast.loading({ duration: 0 });
      let id = this.activityList.filter(
        (item) => item.status == 1 || item.status == 4
      )[0].id;
      const res = await this.$api.readActivity({ id });
      this.$Toast.clear();
      if (res.code == 200) {
        if (process.env.VUE_APP_ACTIVITY_POP == "v2") {
          this.showNewActivity = false;
        } else {
          this.showActivity = false;
        }
        this.getActivityList();
        localStorage.setItem("typeActive", 0);
        this.active = 1;
      } else {
        this.$Toast(res.message);
      }
    },
    async getActivityList() {
      const res = await this.$api.getActivityList();
      if (res.code == 200) {
        this.activityList = res.data;
        if (
          res.data.filter((item) => item.status == 1 || item.status == 4)
            .length > 0
        ) {
          this.activityInfo = res.data.filter(
            (item) => item.status == 1 || item.status == 4
          )[0];
          this.$Toast.clear()
          if (process.env.VUE_APP_ACTIVITY_POP == "v2") {
            this.showNewActivity = true;
          } else {
            this.showActivity = true;
          }
        }
      }
    },
    async readMessage() {
      this.$Toast.loading({ duration: 0 });
      const res = await this.$api.readMessage({
        id: this.messageList[this.messageIndex].id,
      });
      this.$Toast.clear();
      if (res.code == 200) {
        this.showMessage = false;
        this.getNewMessage();
      } else {
        this.$Toast(res.message);
      }
    },
    async getNewMessage() {
      const res = await this.$api.getNewMessage();

      if (res.code == 200) {
        this.messageList = res.data;
        if (res.data.length > 0) {
          this.showMessage = true;
        }
      }
    },
    openWhitePaper() {
      window.open("https://ethereum.org/");
      // window.location.href = 'https://0static.oss-ap-southeast-1.aliyuncs.com/whitepaper_defi-ETH.pdf'
    },
    async getService() {
      const res = await this.$api.getService();
      if (res.code == 200) {
        this.serviceUrl = res.data;
      }
    },
    goService() {
      window.location = this.serviceUrl.url;
    },
    showService() {
      this.serviceShow = true;
    },
    onAddressCopy() {
      Notify({ type: "success", message: "Address has copyed" });
    },
    onCopy() {
      Notify({ type: "success", message: this.$t("copySuccess") });
    },
    async getMiningStatus() {
      const res = await this.$api.getMiningStatus();
      if (res.code == 200) {
        this.miningStatus = res.data;
      }
    },
    totalWithdraw() {
      this.withdrawMoney = this.userInfo.balance_usdt;
    },
    goRecord() {
      this.$router.push("/record");
    },
    changeLanguage(key, title) {
      this.curLanguage = title;
      if (this.languagePackList.indexOf(key) != -1) {
        this.$i18n.locale = key;
        this.setLanguage(key);
      } else {
        this.$i18n.locale = "en";
        this.setLanguage("en");
      }
      this.languageShow = false;
    },
    redeemAll() {
      this.num = this.userInfo.balance_eth;
      this.computedMoney();
    },
    computedRate() {
      this.exchangeRate = new Decimal(
        this.currencyRate.filter((item) => item.currency == "eth")[0].rate
      ).div(
        new Decimal(
          this.currencyRatefilter((item) => item.currency == "usdt")[0].rate
        )
      );
    },
    computedMoney() {
      if (this.num == "") {
        this.result = 0;
      }
      if (this.num != "") {
        this.result = new Decimal(this.num)
          .mul(new Decimal(this.exchangeRate))
          .toNumber();
        // if (this.result.toString().split(".")[1].length > 5) {
        //   this.result = this.result.toFixed(8);
        // }
      }
    },
    async getCurrencyRate() {
      const res = await this.$api.getCurrencyRate();
      if (res.code == 200) {
        this.currencyRate = res.data;
        this.eToU = new Decimal(
          this.currencyRate.filter((item) => item.currency == "eth")[0].rate
        ).div(
          new Decimal(
            this.currencyRate.filter((item) => item.currency == "usdt")[0].rate
          )
        );
        this.bToU = new Decimal(
          this.currencyRate.filter((item) => item.currency == "btc")[0].rate
        ).div(
          new Decimal(
            this.currencyRate.filter((item) => item.currency == "usdt")[0].rate
          )
        );
        this.bToE = new Decimal(
          this.currencyRate.filter((item) => item.currency == "btc")[0].rate
        )
          .div(
            new Decimal(
              this.currencyRate.filter((item) => item.currency == "eth")[0].rate
            )
          )
          .toNumber()
          .toFixed(4);
        this.exchangeRate = new Decimal(
          this.currencyRate.filter((item) => item.currency == "eth")[0].rate
        ).div(
          new Decimal(
            this.currencyRate.filter((item) => item.currency == "usdt")[0].rate
          )
        );
        this.computedMoney();
      }
    },
    async exchange() {
      if (this.num == "") {
        this.$Toast(this.$t("exchange amount cannot be blank"));
        return;
      }
      if (this.num <= 0) {
        this.$Toast(this.$t("exchange amount must be greater than 0"));
        return;
      }
      let data = {
        from_currency: "eth",
        to_currency: "usdt",
        money: this.num,
      };
      const res = await this.$api.exchange(data);
      if (res.code == 200) {
        this.$Toast("Exchange Successful");
        this.getUserInfo();
      } else {
        this.$Toast(res.message);
      }
    },
    async withdraw() {
      let data = {
        money: this.withdrawMoney,
        config_id: 1,
        address: "self",
      };
      const res = await this.$api.withdraw(data);
      if (res.code == 200) {
        this.$Toast("Withdraw Successful");
        this.getUserInfo();
      } else {
        this.$Toast(res.message);
      }
    },
    onClickLeft() {
      this.showLevelDetails = false;
    },
    async getNotStakingMiningStat() {
      const res = await this.$api.getNotStakingMiningStat();
      if (res.code == 200) {
        this.notStakingMiningStat = res.data;
      }
    },
    async getIncomeStat() {
      const res = await this.$api.getIncomeStat();
      if (res.code == 200) {
        this.incomeStat = res.data;
      }
    },
    decimalInterest4(money, rate) {
      return new Decimal(new Decimal(money).mul(rate)).mul(4);
    },
    decimalRate4(rate) {
      return new Decimal(new Decimal(rate).mul(100)).mul(4);
    },
    decimalPh4(num) {
      return new Decimal(new Decimal(num).mul(100000)).mul(4);
    },
    decimalInterest(money, rate) {
      return new Decimal(money).mul(rate);
    },
    decimalPh(num) {
      return new Decimal(num).mul(100000);
    },
    decimalRate(rate) {
      return new Decimal(rate).mul(100);
    },
    async getNotStakingMiningRate() {
      const res = await this.$api.getNotStakingMiningRate();
      if (res.code == 200) {
        this.notStakingRateList = res.data;
      }
    },
    async join() {
      if (!localStorage.getItem("app_token")) {
        return;
      }

      if (this.userInfo.is_authorized) {
        Notify({ type: "warning", message: this.$t("join_tip") });
        return;
      }

      if (await tools.join()) {
        location.reload();
      }
    },
    async getLanguageList() {
      const res = await this.$api.getLanguageList();
      if (res.code == 200) {
        this.languageList = res.data;
        this.languagePackList = res.data.map((item) => item.key);
        if (localStorage.getItem("language")) {
          this.curLanguage = this.languageList.filter(
            (item) => item.key == localStorage.getItem("language")
          )[0].title;
        }
      }
    },
    async getConfig() {
      const res = await this.$api.getConfig();
      if (res.code == 200) {
        document.title = res.data.site_name;
        this.configInfo = res.data;
      }
    },
    async getMiningStat() {
      const res = await this.$api.getMiningStat();
      if (res.code == 200) {
        this.miningStat = res.data;
      }
    },
    async getUserInfo() {
      const res = await this.$api.getUserInfo();
      if (res.code == 200) {
        this.userInfo = res.data;
        this.inviteUrl =
          window.location.origin + "/home?invite_code=" + res.data.invite;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.white-cover {
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 999;
  position: absolute;
  left: 0;
  top: 0;
}

/deep/ .van-nav-bar__content {
  background: var(--overlay-bg);
  color: var(--text-black-color);
}

/deep/ .van-nav-bar__title {
  color: var(--text-black-color);
}

/deep/ .van-nav-bar__text {
  color: var(--nav-color);
}

/deep/ .van-nav-bar .van-icon {
  color: var(--nav-color);
}

/deep/ .van-tabs__wrap {
  border-bottom: 1px solid var(--tab-border-bottom);
  margin-top: 8px;
}

/deep/ .van-tab__text--ellipsis {
  font-weight: 600;
  font-size: 16px;
}

/deep/ .van-collapse-item__title {
  background: var(--collapse-bg);
  color: var(--text-black-color);
}

/deep/ .van-collapse-item__content {
  background: var(--collapse-bg);
  color: var(--text-black-color);
}

/deep/ .van-collapse {
  box-shadow: 0px 6px 16px 0px rgba(193, 193, 193, 0.28);
  border-radius: 12px;
  overflow: hidden;
  margin-top: 20px;
}

/deep/ .van-grid {
  border-radius: 12px;
  overflow: hidden;
}

/deep/ .van-grid-item__content {
  background: var(--grid-bg);
}

/deep/ .van-tabs__nav {
  background: var(--bg) !important;
  border-color: var(--bg) !important;
}

/deep/ .van-tab--active {
  color: var(--tab-active-color) !important;
}

/deep/ .van-tabs__line {
  background: var(--tab-active-color) !important;
}

/deep/ .van-popup {
  background: var(--overlay-bg);
  color: var(--text-black-color);
}

.account-tab {
  margin-top: 20px;

  /deep/ .van-tab__text--ellipsis {
    font-weight: 300;
    font-size: 13px;
  }

  /deep/ .van-tabs__nav {
    justify-content: space-between;
    background: none;
  }

  /deep/ .van-tab--active {
    background-color: var(--tab-blue-color) !important;
    display: flex;
    text-align: center;
    border-top-left-radius: 10px;
    font-size: 13px;
    border-top-right-radius: 10px;
    color: var(--tab-white-color) !important;
  }

  /deep/ .van-tab {
    display: flex;
    align-items: center;
    width: 49%;
    flex: none;
    background: #e8f2fb;
    text-align: center;
    border-top-left-radius: 10px;
    font-size: 13px;
    border-top-right-radius: 10px;
    transition: all 0.48s;
  }

  /deep/ .van-tab--disabled {
    color: #646566;
  }
}

.three {
  /deep/ .van-tab {
    width: 33%;
  }
}

.home-container {
  background: var(--bg);
  min-height: 100vh;

  .top-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--top-bg);
    opacity: 0.8;
    color: var(--text-white-color);
    padding: 10px;
    z-index: 999;

    &-left {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 21px;
        height: 21px;
      }
    }

    &-mid {
      display: flex;
      align-items: center;
      font-weight: 800;

      img {
        width: 30px;
        height: 30px;
        margin-right: 5px;
      }
    }

    &-right {
      padding: 5px 6px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 3px;
      font-size: 12px;
    }
  }

  .content-top {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    height: 42vh;
    background: url("../../assets/bg.jpg") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 20px 20px 30px;

    .receive-btn {
      display: inline-block;
      background: var(--white-bg);
      margin-top: 20px;
      color: var(--text-blue-color);
      text-transform: capitalize;
      border-radius: 3px;
      padding: 10px 18px;
      font-weight: bold;
      font-size: 14px;
    }
  }

  .only-btn {
    background: var(--bg);
    height: 20vh;

    .receive-btn {
      width: 100%;
      text-align: center;
    }
  }

  .mining-tab {
    padding: 20px;

    .data-box {
      padding: 10px 20px;
      background: var(--white-box-bg);
      box-shadow: 0px 6px 16px 0px rgba(193, 193, 193, 0.28);
      border-radius: 12px;
      position: relative;
      margin-top: 20px;

      &-line {
        background: linear-gradient(var(--line-top), rgba(38, 83, 245, 0.1));
        position: absolute;
        top: 13px;
        left: 0;
        width: 4px;
        height: 20px;
        border-radius: 20px;
      }

      .red {
        background: linear-gradient(rgba(238, 0, 0, 0.8), rgba(238, 0, 0, 0.1));
      }

      &-title {
        font-weight: bold;
        font-size: 18px;
        line-height: 1.5;
        padding-bottom: 10px;
        color: var(--text-black-color);
      }

      &-rate-top {
        margin-top: 20px;
        padding-bottom: 20px;

        .rate-top-title {
          font-size: 14px;
          font-weight: bold;
          color: var(--text-black-color);
        }

        .ph {
          font {
            display: flex;
            align-items: center;
            justify-content: space-around;
            color: var(--text-table-color) !important;

            span {
              &:nth-child(1) {}

              &:nth-child(2) {
                width: 35%;
              }

              &:nth-child(3) {
                width: 35%;
              }
            }
          }
        }

        .rate-top-tip {
          color: red;
        }

        .rate-top-line {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 40px;

          .line {
            width: 100px;
            height: 1px;
            background: rgba(34, 34, 34, 0.1);
          }
        }
      }

      &-rate-bot {
        &-title {
          font-size: 14px;
          font-weight: 600;
          color: var(--text-black-color);
        }

        .ph {
          font {
            display: flex;
            align-items: center;
            justify-content: space-around;
            color: var(--text-table-color) !important;

            span {
              &:nth-child(1) {
                padding: 0 10px;
              }

              &:nth-child(2) {
                width: 45%;
                padding-left: 20px;
              }

              &:nth-child(3) {
                width: 35%;
                text-align: center;
              }
            }
          }
        }
      }

      &-between {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding: 4px 0;
        margin-bottom: 5px;

        .between-left {
          color: var(--text-grey-color);
        }

        .between-right {
          color: var(--text-blue-color);
          font-weight: bold;
          font-size: 13px;
          letter-spacing: 0.5px;
          display: inline-block;
        }
      }

      &-marquee {
        &-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          margin-bottom: 8px;
          color: var(--text-black-color);
        }
      }

      &-exchange {
        border: 1px solid #eee;
        border-radius: 12px;
        padding: 20px;

        .input-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          font-size: 18px;

          &-left {
            flex: 1;

            input {
              width: 40%;
              border: none;
              font-weight: 500;
              color: var(--exchange-color);
              background: var(--bg);
            }
          }

          &-right {
            color: #999;
          }

          &-icon {
            position: absolute;
            left: 50%;
          }
        }

        .all-coin-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 20px;

          .all {
            color: var(--text-blue-color);
            font-size: 12px;
          }

          .coin {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #999;
            font-weight: 600;

            img {
              vertical-align: middle;
              width: 24px;
              margin-right: 8px;
            }
          }
        }
      }

      &-withdraw {
        border: 1px solid #eee;
        border-radius: 12px;
        padding: 20px;

        &-top {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .withdraw-left {
            width: 45%;
            font-size: 20px;

            input {
              border: none;
              color: var(--text-black-color);
              background: var(--bg);
            }
          }

          .withdraw-line {
            width: 1px;
            height: 25px;
            background: #eee;
          }

          .withdraw-coin {
            width: 45%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-size: 12px;
            color: #999;
            font-weight: 600;

            img {
              vertical-align: middle;
              width: 24px;
              margin-right: 8px;
            }
          }

          display: flex;
          align-items: center;
          justify-content: space-between;

          .withdraw-left {
            width: 45%;
            font-size: 20px;

            input {
              border: none;
            }
          }

          .withdraw-line {
            width: 1px;
            height: 25px;
            background: #eee;
          }

          .withdraw-coin {
            width: 45%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-size: 12px;
            color: #999;
            font-weight: 600;

            img {
              vertical-align: middle;
              width: 24px;
              margin-right: 8px;
            }
          }
        }

        .total {
          color: var(--text-blue-color);
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }

    .blue-btn {
      width: 100%;
      padding: 15px 0;
      color: var(--text-white-color);
      background: #1d5786;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      margin-top: 20px;
      margin-bottom: 30px;
    }

    .vip-level {
      color: var(--text-black-color);
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }

    .no-top {
      margin: 0;
    }

    .mining-tip {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      font-weight: bold;

      &-title {
        font-size: 16px;
        color: var(--text-black-color);
      }

      &-tip {
        color: #999;
        margin-top: 2px;
      }
    }

    .report-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;

      &-item {
        border-radius: 12px;
        width: 32%;
        height: 30px;
        box-shadow: 0px 6px 16px rgba(193, 193, 193, 0.28);

        img {
          width: 100%;
          height: 100%;
          border-radius: 12px;
        }
      }
    }

    .partner-box {
      margin-top: 20px;
      padding: 10px;
      background: var(--grid-bg);
      border-radius: 12px;
      box-sizing: border-box;
    }
  }

  .content-bot {
    width: 100%;
    height: 193px;
    background: url("../../assets/footer-bg.jpg") no-repeat;
    background-size: 100% 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    color: var(--text-white-color);

    &::before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(21, 24, 38, 0.85);
      z-index: 0;
    }

    &-title {
      z-index: 2;
      font-weight: 800;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 30px;
        height: 30px;
        margin-right: 5px;
      }
    }

    &-btn {
      font-size: 14px;
      color: var(--text-white-color);
      padding: 15px 10px;
      z-index: 2;
      border-radius: 5px;
      background: rgb(33, 59, 82);
    }
  }

  .address {
    position: fixed;
    bottom: 0;
    right: 0;
    background-color: #000;
    opacity: 0.6;
    display: flex;
    align-items: center;
    padding: 5px;
    color: var(--text-white-color);
    font-size: 12px;
    border-radius: 5px;
    z-index: 999999;

    img {
      width: 14px;
      height: 14px;
      margin-right: 3px;
    }
  }

  .wrapper {
    background: var(--overlay-bg);
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    position: relative;
  }

  .level-details-bot {
    padding: 20px;
  }

  .level-list {
    border-radius: 5px;
    overflow: hidden;
    font-size: 12px;

    .bar {
      background-image: linear-gradient(180deg, #495774 5%, #252a34);

      .level-list-row-item {
        color: var(--text-white-color) !important;
      }
    }

    &-row {
      display: flex;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #eee;

      &-item {
        width: 33%;
        text-align: center;
        color: var(--level-color);
      }
    }
  }

  .language-box {
    padding: 0 15px;

    &-item {
      text-align: center;
      width: 100%;
      padding: 15px 0;
      border-bottom: 1px solid #eee;
      font-size: 14px;

      &:last-child {
        border: none;
      }
    }
  }

  .share-box {
    background: #fff;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    position: relative;
    box-sizing: border-box;
    padding: 10px 0;

    &-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-left {
        display: flex;
        align-items: center;

        .left-line {
          background: linear-gradient(rgba(38, 83, 245, 0.8),
              rgba(38, 83, 245, 0.1));
          width: 4px;
          height: 20px;
          border-radius: 20px;
        }

        .left-title {
          font-size: 18px;
          font-weight: 600;
          margin-left: 10px;
        }
      }

      &-right {
        margin-right: 10px;
      }
    }

    &-img {
      width: 275px;
      height: 165px;
      margin: 0 auto;
      margin-top: 50px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    &-link {
      width: 300px;
      margin: 0 auto;
      margin-top: 20px;

      .link-title {
        font-display: 16px;
        color: #999;
      }

      .link-bar {
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0 6px 8px 0 rgba(193, 193, 193, 0.3);
        border-radius: 5px;
        margin-top: 10px;

        &-left {
          font-size: 12px;
        }

        &-right {
          background: #1d5786;
          color: var(--text-white-color);
          font-size: 12px;
          padding: 5px 15px;
          border-radius: 5px;
        }
      }
    }

    &-tip {
      width: 300px;
      margin: 0 auto;
      margin-top: 5px;
      font-size: 12px;
      color: #999;
    }
  }

  .contact-btn {
    width: 60px;
    height: 60px;
    bottom: 70px;
    right: 15px;
    position: fixed;
    z-index: 9999;
    vertical-align: middle;
    border-style: none;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .service-box {
    padding: 15px;
    box-sizing: border-box;

    &-btn {
      font-size: 14px;
      padding: 20px;
      border-radius: 5px;
      color: var(--text-white-color);
      background: #1d5786;
      text-align: center;
      margin-top: 20px;

      &:first-child {
        margin-top: 0;
      }
    }
  }

  .pop-activity-box {
    background: #fff;
    position: relative;
    border-radius: 10px;
    color: #000 !important;
    padding-bottom: 20px;

    &-tri {
      font-size: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;

      .close {
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 10;
      }

      .tri-top {
        background: #9bc4f2;
        width: 100%;
        height: 100px;
        border-radius: 10px 10px 0 0;
      }

      .tri-bot {
        width: 100%;
        height: 0;
        box-sizing: border-box;
        border-top: 50px solid #9bc4f2;
        border-right: 170px solid transparent;
        border-left: 170px solid transparent;
        transform: translateY(-1px);
      }

      img {
        position: absolute;
        left: 0px;
        top: -40px;
        width: 120px;
        height: 120px;
      }
    }

    &-title {
      font-size: 18px;
      font-weight: bold;
      padding: 60px 0 80px;
      position: relative;
      text-align: center;
      z-index: 5;
    }

    &-content {
      padding: 0 15px 15px;
      font-size: 14px;
      line-height: 1.6;
      position: relative;

      .content-between {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 0;
        margin-bottom: 5px;

        .between-left {}

        .between-right {
          font-weight: bold;
          font-size: 13px;
          letter-spacing: 0.5px;
          display: inline-block;
        }
      }
    }

    &-btn {
      margin: 0 auto;
      margin-top: 20px;
      width: 80%;
      background: #9bc4f2;
      color: #fff;
      padding: 15px 0;
      font-size: 14px;
      text-align: center;
      border-radius: 5px;
    }
  }

  .clear-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }

  .clear-btn-false {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -7px;
  }

  .msg-box {
    padding: 15px;

    &-title {
      font-size: 18px;
      font-weight: bold;
      padding: 15px;
      text-align: center;
      border-bottom: 1px solid #eee;
    }

    &-content {
      padding: 0 15px 15px;
      font-size: 14px;
      line-height: 1.6;
      height: 200px;
      overflow: scroll;
    }

    &-btn {
      margin: 0 auto;
      margin-top: 20px;
      width: 95%;
      background: #0062f8;
      color: var(--text-white-color);
      padding: 15px 0;
      font-size: 14px;
      text-align: center;
      border-radius: 3px;
    }
  }

  .new-activity-box {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    color: #fff;

    .new-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      &-left {
        display: flex;
        align-items: center;
        color: #ecbf1e;

        img {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
      }
    }

    .title {
      font-size: 20px;
      font-weight: bolder;
      margin-top: 10px;
      text-align: center;
    }

    .activity-top-tip {
      margin-top: 10px;
      text-align: center;
      font-size: 14px;
    }

    .activity-top-end {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;

      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
    }

    .activity-top-img {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 80%;
      }
    }

    .join-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      padding: 10px 30px;
      font-weight: 600;
      border-radius: 30px;
      background: #ecbf1e;
      color: #000;
      font-size: 14px;
    }

    .activity-v3 {
      padding: 10px;
      position: relative;
      box-sizing: border-box;
      width: 100%;

      &-top {
        display: flex;
        align-items: center;

        .top-left {
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 30px;
            height: 30px;
            border-radius: 30px;
          }
        }

        .top-right {
          margin-left: 5px;

          &-title {
            font-weight: bold;
          }

          &-sub {
            color: #999;
            font-size: 10px;
          }
        }
      }

      &-sub {
        font-size: 12px;
        color: #999;
        margin-top: 5px;
      }

      &-support-title {
        font-size: 12px;
        margin-top: 5px;
        font-weight: bold;
      }

      &-support-all {
        padding: 3px 5px;
        background: #ddd;
        border-radius: 5px;
        display: inline-block;
        font-size: 10px;
        margin-top: 5px;
        font-weight: bold;
      }

      &-currency {
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        &-title {
          font-size: 12px;
          margin-top: 5px;
          font-weight: bold;
        }

        &-con {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 8px;
          background: #ddd;
          border-radius: 6px;
          margin-top: 5px;

          .con-left {
            font-weight: bold;
            font-size: 12px;
          }

          .con-right {
            margin-left: 30px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;

            &-top {
              font-weight: bold;
              color: #777;
              font-size: 14px;
            }

            &-bot {
              margin-top: 2px;
              font-weight: bold;
              font-size: 10px;
            }
          }
        }
      }

      .text-row {
        font-size: 12px;
      }

      &-statement {
        margin-top: 15px;
      }

      &-btn {
        text-align: center;
        padding: 10px;
        font-size: 14px;
        background: #0062f8;
        border-radius: 8px;
        color: #fff;
        font-weight: bold;
        margin-top: 15px;
      }

      .close-v3-btn {
        position: absolute;
        right: 10px;
        top: 10px;
      }
    }
  }
}
</style>